import { Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IProductCategory,
  IProductSubCategory,
} from "../../stateManagement/initial-states/service-category.initial-state";
import {
  IProductCategoryState,
  setMainProductCategory,
} from "../../stateManagement/reducers/productCategoryReducer";
import { setMainRentalItem } from "../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import AnimateButton from "../@extended/AnimateButton";

interface IProps {
  setIsOpen: (isOpen: boolean) => void;
  previewedCategory: IProductCategory;
}

const ProductSubCategoryNav = ({ setIsOpen, previewedCategory }: IProps) => {
  const { mainSubCategoryIndex, mainCategory } = useSelector<
    IRootReducerT,
    IProductCategoryState
  >((state) => state.productCategory);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setIsOpen(false);
    });
  }, []);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100% !important",
        overflowX: "auto !important",
        flexWrap: "nowrap",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderTop: "solid 1px #e3e3de99",
        backgroundColor: "#faf9f6b8 !important",
        backdropFilter: "blur(4px) saturate(140%)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={4}
        id="product-sub-category-nav"
        sx={{
          px: "1rem",
          py: ".5rem",
          marginLeft: "auto !important",
          marginRight: "auto !important",
          display: { xs: "flex", md: "flex", lg: "flex" },
          backgroundColor: "transparent",
        }}
      >
        {previewedCategory.subCategories.map(
          (subCategory: IProductSubCategory, index: number) => {
            const isMainSubCategory =
              mainCategory.name === previewedCategory.name &&
              index === mainSubCategoryIndex;

            return (
              <AnimateButton>
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    cursor: "pointer",
                    transition: "all .25s 0s ease-out",
                    borderRadius: "1.5rem",
                    p: ".5rem",
                    px: "1rem",
                    fontFamily: "Inter",
                    fontSize: ".9rem",
                    textWrap: "nowrap",
                  }}
                  className={`hover:bg-primary hover:text-white ${
                    isMainSubCategory ? "bg-primary text-white" : "text-grey"
                  }`}
                  onClick={() => {
                    dispatch(
                      setMainProductCategory({
                        category: previewedCategory,
                        subCategoryIndex: index,
                      }),
                    );
                    setIsOpen(false);
                    dispatch(setMainRentalItem(null));
                  }}
                >
                  {subCategory.name}
                </Typography>
              </AnimateButton>
            );
          },
        )}
      </Stack>
    </Stack>
  );
};

export default ProductSubCategoryNav;
